import classNames from 'classnames';
import React from 'react';
import styles from "./plan-price.module.css";
/**
 * PlanPrice component that encapsulates logic for displaying list price or discount price with strikethrough list price
 * @param listPriceText
 * @param discountPriceText
 * @param listPriceTextClassName
 * @param discountPriceTextClassName
 * @constructor
 */
export const PlanPrice = ({
  listPriceText,
  discountPriceText,
  listPriceTextClassName,
  discountPriceTextClassName
}) => {
  const priceElement = discountPriceText ? /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement("span", {
    className: classNames(styles['list-price-strikethrough'], listPriceTextClassName)
  }, listPriceText), /*#__PURE__*/React.createElement("span", {
    className: discountPriceTextClassName
  }, `${discountPriceText} `)) : /*#__PURE__*/React.createElement("span", {
    className: listPriceTextClassName
  }, listPriceText);
  return /*#__PURE__*/React.createElement(React.Fragment, null, priceElement);
};
//# sourceMappingURL=plan-price.react-component.js.map